import React, { useEffect, useState, Fragment } from 'react';
import {
  Row,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  CustomInput,
} from 'reactstrap';
import moment from 'moment';
import {
  postAPI_PublishGPT,
  API_Ingetration,
  gAPI_Users_By_Id,
  API_OpenAI_Assistant,
  gAPI_QuestionSets,
  API_Publish_Assistant,
} from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
const style_css = `
.modal-content .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color:var(--theme-color-1) !important;
  border-color:var(--theme-color-1) !important;
  color: white; 
}
.modal-content .custom-checkbox .custom-control-label::before {
  background-color: transparent !important; 
  border-color:rgb(188, 192, 192) !important;
}
`;
function PublishModel({
  propertyId,
  locale,
  email,
  toggleModal,
  visible,
  type,
  selectedItems,
  convesationId,
  result,
}) {
  const [isEnabled, setIsEnabled] = useState(false);
  const [userName, setUserName] = useState('');

  const [isButtonShow, setIsButtonShow] = useState(true);
  const [checkboxes, setCheckboxes] = useState({
    pii: false,
    confidentiality: false,
    harmfulfree: false,
  });

  const [isFormValid, setIsFormValid] = useState(false);
  useEffect(() => {
    let body = {
      channels: ['WebsiteDirectLine'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      const webIntegrationData = res.data.filter(
        (k) =>
          k.channel === 'WebsiteDirectLine' &&
          k.disabled === false &&
          k.properties.includes(propertyId)
      );
      webIntegrationData.map((k) => {
        var botsetting = k.botSettings;
        if (
          (botsetting.features !== null &&
            botsetting.features.generativeChatGPT === true) ||
          botsetting.features.generativeGPT3 === true
        ) {
          setIsEnabled(true);
        }
      });
    });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      setIsButtonShow(false);
      setUserName(res.data.fullName);
    });
  }, [propertyId]);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prev) => {
      const updatedCheckboxes = { ...prev, [name]: checked };
      setIsFormValid(
        updatedCheckboxes.pii &&
        updatedCheckboxes.confidentiality &&
        updatedCheckboxes.harmfulfree
      );
      return updatedCheckboxes;
    });
  };

  const handleDynamicPublish = (e) => {
    if (result.filter((f) => f.id === convesationId).length > 0) {
      toggleModal();
      let data = result.filter((f) => f.id === convesationId)[0];
      NotificationManager.success(
        '',
        'We are processing your request. The changes are Live in under a minute',
        3000,
        null,
        null,
        'success'
      );
      AxiosAPI({
        method: 'post',
        url: `${API_Publish_Assistant}`,
        data: {
          id: convesationId,
          includedItems:
            selectedItems.length >= 2
              ? {
                includeFAQ: selectedItems[2].includeFAQ,
                includeKnowledgeHub: selectedItems[2].includeKnowledgeHub,
                includeDocuments: selectedItems[2].includeDocuments,
              }
              : {},
        },
      }).then((res) => {
        toggleModal();
        try {
          let functions = [];
          if (
            data.flowInvokeApi !== undefined &&
            data.flowInvokeApi.isEnabled !== undefined &&
            data.flowInvokeApi.isEnabled === true
          ) {
            if (
              data.flowInvokeApi.json !== undefined &&
              data.flowInvokeApi.json.length > 0
            ) {
              data.flowInvokeApi.json.map((m) => {
                if (m !== '') functions.push(JSON.parse(m));
              });
            }
          }
          let body = {
            instructions: data.instructions,
            model: data.openAiModel,
            name: data.name,
            id: convesationId,
            function: functions.map((f) => f),
            vector_id: res.data.status !== null ? res.data.status : '',
            type: 'PublishAI',
            content: {
              includedItems: (
                (selectedItems[2].includeFAQ ? 'FAQ,' : '') +
                (selectedItems[2].includeKnowledgeHub
                  ? ' Knowledge Templates Data,'
                  : '') +
                (selectedItems[2].includeDocuments ? ' Documents' : '')
              ).trim(','),
              type: 'Dynamic Conversation for AI Chatbot',
              status: 'Published',
              instructions: data.setInstructions,
              model: data.openAiModel,
              name: data.name,
              flowInvokeApi: data.flowInvokeApi,
              flowTrainingData: data.flowTrainingData,
            },
            action: 'Requested By ' + userName + ' at ',
          };
          if (
            res.data.status !== undefined &&
            res.data.status !== null &&
            res.data.status !== ''
          )
            body.vector_id = res.data.status !== null && res.data.status;
          if (
            data.openAiAssistantId !== undefined &&
            data.openAiAssistantId !== null &&
            data.openAiAssistantId !== ''
          ) {
            AxiosAPI({
              method: 'put',
              url: `${API_OpenAI_Assistant}/update/${data.openAiAssistantId}`,
              data: body,
            }).then((res) => {
              toggleModal();
            });
          } else {
            AxiosAPI({
              method: 'post',
              url: `${API_OpenAI_Assistant}/create`,
              data: body,
            }).then((res) => {
              toggleModal();
            });
          }
        } catch (error) {
          console.error(error);
        }
      });
    }
  };

  const handlePublish = () => {
    let isCopilot = false;
    if (type !== undefined && type === 'Copilot') isCopilot = true;
    if (type !== undefined && type === 'Dynamic') handleDynamicPublish();
    else {
      var body = {
        GroupId: getGroupID(),
        PropertyId: propertyId,
        Language: locale === 'en' ? 'en-US' : locale,
        email: email,
        version: 3,
        content: {
          includedItems: (
            (selectedItems[0].includeFAQ ? 'FAQ,' : '') +
            (selectedItems[0].includeKnowledgeHub
              ? 'Knowledge Templates Data, '
              : '') +
            (selectedItems[0].includeDocuments ? 'Documents,' : '') +
            (selectedItems[0].includeWebWidgetMenus
              ? 'Web Widget Menus,'
              : '') +
            (selectedItems[0].includeDigitalCompendium
              ? 'Digital Compendium,'
              : '') +
            (selectedItems[0].includedProductsAndServices
              ? 'Products & Services'
              : '') +
            (selectedItems[0].includeRoomTypes ? 'Room Types' : '')
          ).trim(','),
          type: 'Gen AI Model for AI Chatbot',
          status: 'Queued',
        },
        action: 'Requested By ' + userName + ' at ',
        Creator: 'dashboard',
        isCopilot: isCopilot,
        includedItems: isCopilot
          ? selectedItems.length >= 1
            ? {
              includeFAQ: selectedItems[1].includeFAQ,
              includeKnowledgeHub: selectedItems[1].includeKnowledgeHub,
              includeDocuments: selectedItems[1].includeDocuments,
            }
            : {}
          : selectedItems.length >= 0
            ? {
              includeFAQ: selectedItems[0].includeFAQ,
              includeKnowledgeHub: selectedItems[0].includeKnowledgeHub,
              includeDocuments: selectedItems[0].includeDocuments,
              includeWebWidgetMenus: selectedItems[0].includeWebWidgetMenus,
              includeDigitalCompendium:
                selectedItems[0].includeDigitalCompendium,
              includedProductsAndServices:
                selectedItems[0].includedProductsAndServices,
              includeRoomTypes: selectedItems[0].includeRoomTypes,
            }
            : {},
      };
      AxiosAPI({
        method: 'post',
        url: `${postAPI_PublishGPT}`,
        data: body,
      }).then(() =>
        NotificationManager.success(
          '',
          'We have received your request. Publish will take few minutes.',
          3000,
          null,
          null,
          'success'
        )
      );
      toggleModal();
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggleModal}>
        <style>{style_css}</style>
        <ModalHeader toggle={toggleModal}>Confirm to Publish GPT</ModalHeader>
        <ModalBody>
          <h6 className="mb-2">I acknowledge that:</h6>
          <FormGroup className="modal-content">
            <CustomInput
              type="checkbox"
              id="pii"
              name="pii"
              label="Data does not contain any personally identifiable information (PII)."
              checked={checkboxes.pii}
              onChange={handleCheckboxChange}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type="checkbox"
              id="confidentiality"
              name="confidentiality"
              label="Data does not contain any confidential, restricted, or commercially sensitive information."
              checked={checkboxes.confidentiality}
              onChange={handleCheckboxChange}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type="checkbox"
              id="harmfulfree"
              name="harmfulfree"
              label="The data is free from harmful, abusive, or biased content."
              checked={checkboxes.harmfulfree}
              onChange={handleCheckboxChange}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={!isFormValid}
            onClick={() => handlePublish()}
          >
            Publish GPT
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps)(PublishModel));
